import { render, staticRenderFns } from "./DeactivateMember.vue?vue&type=template&id=411199aa"
import script from "./DeactivateMember.vue?vue&type=script&lang=js"
export * from "./DeactivateMember.vue?vue&type=script&lang=js"
import style0 from "./DeactivateMember.vue?vue&type=style&index=0&id=411199aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports